import { useState, useEffect, Suspense, lazy } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./style/LandindPages.scss";
import moment from "moment-timezone";
import Base from "./Components/Layout/Base";
// import Signup from "./Components/Elements/Signup";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./Components/Elements/PrivateRoute";
import global_en from "./translations/en/global.json";
import global_fr from "./translations/fr/global.json";
import i18next from "i18next";
import { CounterContextProvider } from "./Components/Elements/Meeting/context/CounterContext";
import axios from "axios";
import { API_BASE_URL } from "./Components/Apicongfig";
import BasePage from "./Components/Layout/BasePage";
import { StepCounterContextProvider } from "./Components/Elements/Meeting/context/StepCounterContext.js";
import { messaging } from "./firebase.js";
import { onMessage } from "firebase/messaging";
import { closeSnackbar, useSnackbar } from "notistack";
import notificationSound from "./Media/notification.mp3";
import AccessControl from "./Components/Elements/AccessControl";
import CookieService from "./Components/Utils/CookieService";
import { setupAxiosInterceptors } from "./Components/Utils/auth";
import { subscribeToUser, unsubscribeFromUser } from "./Helpers/pusherHelper";

// Lazy-loaded components to improve initial bundle size and page speed
const Login = lazy(() => import("./Components/Elements/Login"));
const Profile = lazy(() => import("./Components/Elements/Profile/Profile"));
const Contract = lazy(() => import("./Components/Elements/Contract/Contract"));
const Enterprises = lazy(() => import("./Components/Elements/Enterprises/Enterprises"));
const NewEnterprises = lazy(() => import("./Components/Elements/Enterprises/NewEnterprises"));
const Team = lazy(() => import("./Components/Elements/Team/Team"));
const Invities = lazy(() => import("./Components/Elements/Invities/Invities"));
const UpdateContract = lazy(() => import("./Components/Elements/Contract/UpdateContract"));
const UpdateEntreprises = lazy(() => import("./Components/Elements/Enterprises/UpdateEntreprises"));
const UpdateTeam = lazy(() => import("./Components/Elements/Team/UpdateTeam"));
const Users = lazy(() => import("./Components/Elements/User/Users"));
const ContractLinkEntreprises = lazy(() => import("./Components/Elements/LinkPages/ContractLinkEntreprises"));
const ContractToTeam = lazy(() => import("./Components/Elements/LinkPages/ContractToTeam"));
const EntreprisesToTeam = lazy(() => import("./Components/Elements/LinkPages/EntreprisesToTeam"));
const CopyContract = lazy(() => import("./Components/Elements/Contract/CopyContract"));
const CopyClosedContract = lazy(() => import("./Components/Elements/Contract/CopyClosedContract"));
const ReadContract = lazy(() => import("./Components/Elements/Contract/ReadContract"));
const UpdateUser = lazy(() => import("./Components/Elements/User/UpdateUser"));
const ContractToUser = lazy(() => import("./Components/Elements/LinkPages/ContractToUser"));
const EnterprisesToUser = lazy(() => import("./Components/Elements/LinkPages/EnterprisesToUser"));
const MeetingTabs = lazy(() => import("./Components/Elements/Meeting/MeetingTabs"));
const ActionPlay = lazy(() => import("./Components/Elements/Actions/ActionPlay"));
const Invite = lazy(() => import("./Components/Elements/Meeting/CurrentMeeting/Invite"));
const UpdatePassword = lazy(() => import("./Components/Elements/User/UpdatePassword"));
const Report = lazy(() => import("./Components/Elements/Meeting/Report"));
const CompletedInvite = lazy(() => import("./Components/Elements/Meeting/CompletedMeeting/CompletedInvite"));
const DestinationToMeetings = lazy(() => import("./Components/Elements/Invities/DestinationToMeeting/DestinationToMeetings"));
const About = lazy(() => import("./Pages/About"));
const Privacypolicy = lazy(() => import("./Pages/Privacypolicy"));
const Termsandconditions = lazy(() => import("./Pages/Termsandconditions"));
const SearchEngine = lazy(() => import("./Pages/SearchEngine"));
const SearchResultsPage = lazy(() => import("./Pages/SearchResultsPage"));
const ProfileInvitePage = lazy(() => import("./Components/Elements/Profile/ProfileInvitePage"));
const NewsletterTerms = lazy(() => import("./Pages/NewsletterTerms.jsx"));
const ActionTabs = lazy(() => import("./Components/Elements/Actions/ActionTabs.jsx"));
const SolutionTabs = lazy(() => import("./Components/Elements/Solution/SolutionTabs.jsx"));
const Solution = lazy(() => import("./Components/Elements/Solution/GetSolution/Solution.jsx"));
const CompletedDoneStep = lazy(() => import("./Components/Elements/Meeting/CompletedMeeting/CompletedDoneStep.jsx"));
const AddQuestionField = lazy(() => import("./Components/Elements/QuestionsField/AddQuestionField.jsx"));
const CreateUsers = lazy(() => import("./Components/Elements/User/CreateUsers.jsx"));
const ClientDetail = lazy(() => import("./Components/Elements/Team/Client/ClientDetail.jsx"));
const MemberDetail = lazy(() => import("./Components/Elements/Team/Member/MemberDetail.jsx"));
const MeetingPreview = lazy(() => import("./Components/Elements/Meeting/MeetingPreview.jsx"));
const ContactDetail = lazy(() => import("./Components/Elements/Team/Contact/ContactDetail.jsx"));
const CastingMemberDetail = lazy(() => import("./Components/Elements/Team/Member/CastingMemberDetail.jsx"));
const CastingContactDetail = lazy(() => import("./Components/Elements/Team/Contact/CastingContactDetail.jsx"));
const Register = lazy(() => import("./Components/Elements/Register.jsx"));
const ReferralLanding = lazy(() => import("./Components/Elements/ReferralLanding.jsx"));
const DiscussionTabs = lazy(() => import("./Components/Elements/Discussion/DiscussionTabs.jsx"));
const Settings = lazy(() => import("./Components/Elements/Profile/Settings.jsx"));
const Integrations = lazy(() => import("./Components/Elements/Profile/Integrations.jsx"));
const Assistant = lazy(() => import("./Components/Elements/Profile/Assistant.jsx"));
const PaymentSuccess = lazy(() => import("./Pages/PaymentSuccess.jsx"));
const PaymentCancel = lazy(() => import("./Pages/PaymentCancel.jsx"));
const AccessDenied = lazy(() => import("./Pages/AccessDenied"));
const NotFound = lazy(() => import("./Pages/NotFound.jsx"));
const HomeMessages = lazy(() => import("./Pages/Discussion/HomeMessages.jsx"));
const StripeSuccess = lazy(() => import("./Components/Elements/StripeSuccess"));
const StripePaymentCompleted = lazy(() => import("./Components/Elements/StripePaymentCompleted"));
const StripePaymentCancel = lazy(() => import("./Components/Elements/StripePaymentCancel"));
const LinkedInCallback = lazy(() => import("./Pages/LinkedInCallback.jsx"));
const SubscriptionExpiredPage = lazy(() => import("./Pages/SubscriptionExpiredPage"));

i18next.init({
  interpolation: { escapevalue: false },
  lng: "fr",
  resources: {
    en: {
      global: global_en,
    },
    fr: {
      global: global_fr,
    },
  },
});

//
// Define all valid public and private routes
const publicRoutes = [
  "/",
  "/search-results",
  "/login",
  "/signup",
  "/about",
  "/contact",
  "/privacy-policy",
  "/terms&conditions",
  "/contactus",
  "/pricing",
  "/useCase/1",
  "/useCase/2",
  "/useCase/3",
  "/useCase/4",
  "/payment-success",
  "/payment-cancel",
  "/stripe/success",
  "/stripe/completed",
  "/stripe/cancel",
  "/stripe/refresh",
  "/auth/linkedin/callback",
  "/subscription-expired",
];

const privateRoutes = [
  "/profile",
  "/contract",
  "/CopyContract",
  "/CopyClosedContract",
  "/ModifierContract",
  "/ContractLinkEnterprises",
  "/readContract",
  "/ContractToTeam",
  "/ContractToUser",
  "/EntreprisesToTeam",
  "/EntreprisesToUsers",
  "/Enterprises",
  "/NewEnterprises",
  "/ModifierEnterprises",
  "/Team",
  "/ModifierTeam",
  "/Users",
  "/ModifierUser",
  "/Invities",
  "/invitiesToMeeting",
  "/participantToAction",
  "/updateParticipant",
  "/meeting",
  "/updatepassword",
  "/meetingDetail",
  "/play",
  "/actīon/play",
  "/PlayMeeting",
  "/view",
  "/invite",
  "/destination/:unqiue_id/:meeting_id",
  "/newsletter/terms-and-conditions",
  "/present/invite",
  "/step",
  "/todo-step",
  "/action",
  "/solution",
  "/question",
  "/message/:id",
  "/solution",
];

// Function to check if the route is valid
const isValidRoute = (path, isSignedIn) => {
  return publicRoutes.includes(path) || privateRoutes.includes(path);
};

function App() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();

  const navigate = useNavigate();
  const [isSignedIn, setIsSignedIn] = useState(() => {
    return !!CookieService.get("token");
  });

  console.log("m...");
  useEffect(() => {
    // Setup axios interceptors
    setupAxiosInterceptors(navigate);

  }, [navigate]);

  useEffect(() => {
    if (!messaging) {
      console.warn(
        "Firebase Messaging not available, skipping onMessage listener"
      );
      return;
    }

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("🔔 Foreground message received:", payload);

      const title =
        payload.notification?.title ||
        payload.data?.title ||
        "New Notification";
      const body = payload.notification?.body || payload.data?.body || "";
      const image =
        payload.notification?.image ||
        payload.data?.image ||
        "/icons/icon-192x192.png";

      const audio = new Audio(notificationSound);
      audio.play().catch((err) => console.log("Sound error:", err));

      enqueueSnackbar(body, {
        variant: "default",
        anchorOrigin: { vertical: "top", horizontal: "center" },
        autoHideDuration: 5000,
        content: (key, message) => {
          const url =
            payload.data?.click_action || payload.notification?.click_action;

          return (
            <div
              key={key}
              onClick={() => {
                if (url) {
                  navigate(url, { state: { from: "meeting" } });
                }
                closeSnackbar(key);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                background: "linear-gradient(135deg, #ffffff, #f9f9f9)",
                padding: "1.25rem",
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                maxWidth: 420,
                width: "100%",
                gap: "1rem",
                cursor: "pointer",
                animation: "fadeSlideIn 0.3s ease",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <img
                src={image || "/icons/icon-192x192.png"}
                alt="Notification"
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: "12px",
                  objectFit: "cover",
                  objectPosition: "left",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "17px",
                    fontWeight: 700,
                    color: "#1a1a1a",
                    marginBottom: "0.35rem",
                  }}
                >
                  {title}
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    color: "#4a4a4a",
                    lineHeight: 1.4,
                  }}
                >
                  {message}
                </div>
              </div>
              <style>
                {`
                  @keyframes fadeSlideIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                  }
                `}
              </style>
            </div>
          );
        },
      });
    });

    return () => unsubscribe();
  }, [enqueueSnackbar, navigate]);

  //   useEffect(()=>{
  //     // getFcmToken()
  //  // Handle incoming messages when app is in foreground
  // onMessage(messaging, (payload) => {
  //   console.log("Foreground message received:", payload);

  //   // Customize how you want to show the notification
  //   const notificationTitle = payload.notification?.title || payload.data?.title;
  //   const notificationOptions = {
  //     body: payload.notification?.body || payload.data?.body,
  //     icon: '/icons/icon-192x192.png',
  //     image: payload.notification?.image || payload.data?.image
  //   };

  //   // Show notification using the Notification API
  //   if (Notification.permission === "granted") {
  //     new Notification(notificationTitle, notificationOptions);
  //   } else {
  //     console.log("Notification permission not granted");
  //   }
  // });
  //   },[])
  const [removeLogo, setRemoveLogo] = useState(false);

  const signin = () => {
    setIsSignedIn(true);
    setRemoveLogo(true);
  };

  const signout = async () => {
    // 1. Capture necessary data BEFORE clearing cookies
    const token = CookieService.get("token");
    const userId = CookieService.get("user_id");
    const logoutTime = new Date().toLocaleString(); 

    // 2. Clear local session IMMEDIATELY for better UX
    CookieService.set("logoutTime", logoutTime);
    setIsSignedIn(false);
    setRemoveLogo(false);
    localStorage.removeItem("subscription_expired");
    sessionStorage.removeItem("subscription_expired");
    localStorage.removeItem("payment_url");
    sessionStorage.removeItem("payment_url");
    CookieService.clear();

    // 3. Navigate to login RIGHT AWAY
    navigate("/");

    // 4. Send logout notification to server in the background
    if (token && userId) {
      updateUserWithToken(userId, token);
    }
  };

  useEffect(() => {
    const userTimezone = moment.tz.guess();

    CookieService.set("timezone", userTimezone);
  }, []);

  // Update function with explicit token passing to support background logout
  const updateUserWithToken = async (userId, token, useBeacon = false) => {
    const id = parseInt(userId);
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const payload = {
      user_id: id,
    };

    if (useBeacon) {
      const url = `${API_BASE_URL}/logout`;
      navigator.sendBeacon(url, JSON.stringify(payload));
    } else {
      try {
        await axios.post(`${API_BASE_URL}/logout`, payload, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        console.error("Error updating User background logout:", error);
      }
    }
  };

  // Original updateUser for other cases (if needed)
  const updateUser = async (useBeacon = false) => {
    const userId = CookieService.get("user_id");
    const token = CookieService.get("token");
    if (userId && token) {
      return updateUserWithToken(userId, token, useBeacon);
    }
  };


  useEffect(() => {
    const hasToken = !!CookieService.get("token");
    const isMobileHost = window.location.hostname === "mobile.tektime.io";
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (hasToken && (location.pathname === "/" || location.pathname === "/login")) {
      navigate("/meeting");
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!isSignedIn) return;

    const userId = CookieService.get("user_id");
    if (!userId) return;

    const channel = subscribeToUser(userId, ({ type, data }) => {
      if (type === "trial.expired") {
        console.log("Pusher trial.expired event received via helper:", data);
        const paymentUrl = data?.subscription?.stripe_payment_link || data?.payment_url || data?.stripe_payment_link || '';
        sessionStorage.setItem("subscription_expired", "true");
        localStorage.setItem("subscription_expired", "true");
        if (paymentUrl) {
          sessionStorage.setItem("payment_url", paymentUrl);
          localStorage.setItem("payment_url", paymentUrl);
        }
        window.location.href = `/subscription-expired?payment_url=${encodeURIComponent(paymentUrl)}`;
      }
    });

    return () => {
      unsubscribeFromUser(userId);
    };
  }, [isSignedIn, navigate]);
  function refreshAccessToken() {
    const refreshToken = CookieService.get("refresh_token");

    if (!refreshToken) {
      console.error("No refresh token available");
      return;
    }
    const userid = CookieService.get("user_id");

    axios
      .post(
        `${API_BASE_URL}/auth/refresh`,
        {
          // refresh_token: refreshToken,
          user_id: userid,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response) {
          const newAccessToken = response.data.access_token;
          const newExpiresIn = response.data.expires_in; // e.g., 3598 seconds

          // Update the stored tokens and expiration time
          CookieService.set("access_token", newAccessToken);

          const newExpirationTime = Date.now() + newExpiresIn * 1000;
          CookieService.set("token_expiration_time", newExpirationTime);

          // Set a new timeout to refresh the access token again
          setTimeout(refreshAccessToken, (newExpiresIn - 60) * 1000); // Refresh 1 minute before expiration
        }
      })
      .catch((error) => {
        handleInvalidToken();
      });
  }

  function handleInvalidToken() {
    CookieService.remove("access_token");
    CookieService.remove("refresh_token");
    CookieService.remove("token_expiration_time");
  }

  // Function to check token expiration and refresh
  function checkTokenExpiration() {
    const tokenExpirationTime = CookieService.get("token_expiration_time");
    if (!tokenExpirationTime) return;

    const currentTime = Date.now();
    if (currentTime > tokenExpirationTime) {
      CookieService.remove("access_token");
      CookieService.remove("token_expiration_time");
      refreshAccessToken();
    } else {
      console.log("not expired now!");
    }
  }


  useEffect(() => {
    const intervalId = setInterval(() => {
      const tokenExpirationTime = CookieService.get("token_expiration_time");
      if (!tokenExpirationTime) return;

      const currentTime = Date.now();
      if (currentTime > parseInt(tokenExpirationTime)) {
        console.log("Token expired, refreshing...");
        refreshAccessToken();
      }
    }, 60 * 1000);

    return () => clearInterval(intervalId);
  }, []);


  return (
    <div>
      <ToastContainer
        autoClose={3000}
        closeOnClick
      // style={{
      //   position: "absolute",
      //   zIndex: "4",
      // }}
      />

      <Suspense fallback={
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
          <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      }>
        <Routes>
        {/* <Route path="/" element={<Login onLogin={signin} />} /> */}
        <Route path="/" element={<Login onLogin={signin} />} />
        <Route path="/login" element={<Login onLogin={signin} />} />
        <Route
          path="/heroes/:nick_name/emissary/:referral_id"
          element={<ReferralLanding />}
        />
       

        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="/stripe/success" element={<StripeSuccess />} />
        <Route path="/stripe/completed" element={<StripePaymentCompleted />} />
        <Route path="/stripe/cancel" element={<StripePaymentCancel />} />
        <Route path="/stripe/refresh" element={<StripePaymentCancel />} />
        <Route path="/subscription-expired" element={<SubscriptionExpiredPage />} />
        <Route
          path="/heroes/:nick_name"
          element={<ProfileInvitePage onLogout={signout} />}
        />
        <Route path="/auth/linkedin/callback" element={<LinkedInCallback />} />
        <Route
          element={
            <Base
              isAuthenticated={isSignedIn}
              onLogout={signout}
              onLogin={signin}
              onRemove={removeLogo}
            />
          }
        >
          {CookieService.get("type") === "MasterAdmin" &&
            CookieService.get("type") != "SuperAdmin" &&
            CookieService.get("type") != "Admin" && (
              <Route
                path="/contract"
                element={
                  <PrivateRoute isSignedIn={isSignedIn}>
                    <Contract onLogout={signout} />
                  </PrivateRoute>
                }
              />
            )}
          <Route
            path="/CopyContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CopyContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/CopyClosedContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CopyClosedContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractLinkEnterprises/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractLinkEntreprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/readContract/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ReadContract onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractToTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractToTeam onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ContractToUser/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContractToUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/EntreprisesToTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <EntreprisesToTeam onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/EntreprisesToUsers/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <EnterprisesToUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Enterprises"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Enterprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/NewEnterprises"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <NewEnterprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierEnterprises/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateEntreprises onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Team"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="casting_need"> */}
                  <Team onLogout={signout} />
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />
          <Route
            path="/client/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ClientDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/member/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <MemberDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/casting/member/:destination_id/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CastingMemberDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/contact/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ContactDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/casting/contact/:destination_id/:id"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CastingContactDetail onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/discussion"
            exact
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="discussion_need"> */}
                  <DiscussionTabs onLogout={signout} />
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierTeam/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateTeam onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/Users/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Users onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/user/create"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CreateUsers onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/ModifierUser/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateUser onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/Invities"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="mission_need"> */}
                  <Invities onLogout={signout} />
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />
          <Route
            path="/invitiesToMeeting/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <DestinationToMeetings onLogout={signout} />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/participantToAction/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <ParticipantToAction onLogout={signout} />
              </PrivateRoute>
            }
          /> */}

          {/* <Route
            path="/updateParticipant/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdateParticipant onLogout={signout} />
              </PrivateRoute>
            }
          /> */}

          <Route
            path="/meeting"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="meeting_need"> */}
                  <MeetingTabs onLogout={signout} />
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Profile onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile/integrations"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Integrations onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile/assistant"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Assistant onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile/settings"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Settings onLogout={signout} />
              </PrivateRoute>
            }
          />

          {/* UpdatePassword Route */}
          <Route
            path="/updatepassword"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <UpdatePassword onLogout={signout} />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/participant/:id"
            element={<UpdateParticipant onLogout={signout} />}
          /> */}

          {/* <Route
            path="/play/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CounterContextProvider>
                  <Play onLogout={signout} />
                </CounterContextProvider>
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/actīon-play/:id/:step_Id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <StepCounterContextProvider>
                  <ActionPlay onLogout={signout} />
                </StepCounterContextProvider>
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/PlayMeeting/:id"
            element={
              <CounterContextProvider>
                <PlayMeeting />
              </CounterContextProvider>
            }
          /> */}
          <Route
            path="/view/:id"
            element={<MeetingPreview onLogout={signout} />}
          />


          <Route
            path="/invite/:id"
            element={
              // <StepCounterContextProvider>
              <Invite onLogout={signout} />
              // </StepCounterContextProvider>
            }
          />
          <Route
            path="/destination/:unqiue_id/:meeting_id"
            element={
              <CounterContextProvider>
                <Report />
              </CounterContextProvider>
            }
          // element={<Presentationreport />}
          />
          <Route
            path="/newsletter/terms-and-conditions"
            element={<NewsletterTerms />}
          // element={<Presentationreport />}
          />

          <Route
            path="/present/invite/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CompletedInvite onLogout={signout} />
              </PrivateRoute>
            }
          />

          <Route
            path="/step/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CompletedDoneStep onLogout={signout} />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/todo-step/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <TodoStepScreen onLogout={signout} />
              </PrivateRoute>
            }
          /> */}
          {/* <Route
            path="/customer-support"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <CustomerSupport onLogout={signout} />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/action"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="action_need"> */}
                  <StepCounterContextProvider>
                    <ActionTabs onLogout={signout} />
                  </StepCounterContextProvider>
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />

          <Route
            path="/solution"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                {/* <AccessControl need="solution_need"> */}
                  <SolutionTabs onLogout={signout} />
                {/* </AccessControl> */}
              </PrivateRoute>
            }
          />
          <Route
            path="/question"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <AddQuestionField onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/message/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <AddQuestionField onLogout={signout} />
              </PrivateRoute>
            }
          />
          <Route
            path="/solution/:id"
            element={
              <PrivateRoute isSignedIn={isSignedIn}>
                <Solution onLogout={signout} />
              </PrivateRoute>
            }
          />
        </Route>
        {/* Page 404 : rendue seulement si aucune route (ni ce bloc, ni le bloc
            BasePace ci-dessous) ne correspond — NotFound rend null sur les
            chemins vitrine pour éviter toute superposition. */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      <BasePage>
        <Routes>
          {/* <Route path="/" element={<SearchEngine />} /> */}
          <Route path="/search-results" element={<SearchResultsPage />} />
          {/* <Route path="/old-home" element={<Home />} /> */}
          <Route path="/register/:referral_id?" element={<Register />} />
          {/* <Route
            path="/gate/moment/:referral_id?"
            element={<RegisterMoment />}
          />
          <Route
            path="/gate/mission/:referral_id?"
            element={<RegisterMission />}
          />
          <Route path="/gate/btp/:referral_id?" element={<RegisterBtp />} /> */}
          <Route path="/about" element={<About />} />
          {/* <Route path="/contact" element={<Contactus />} /> */}
          <Route path="/privacy" element={<Privacypolicy />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route
            path="/gate/:name"
            element={<HomeMessages />}
          />
          <Route
            path="/terms-and-conditions"
            element={<Termsandconditions />}
          />

        </Routes>
      </BasePage>
      </Suspense>
    </div>
  );
}

export default App;
